export { default } from './CompactListItem';



// WEBPACK FOOTER //
// ./app/components/shared/CompactListItem/index.js